import store from '@vuex'
import https from '@axios'
import router from '@router'
let deleteNull = {
    https,
    isiOS: function(url) {
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端 
        if (isiOS) {
            window.location.href = url
        } else {
            window.location.href = url
        }
    },
    userOut: function() {},
    windowopen: function(obj) {
        window.open(router.resolve(obj).href, "_blank");
    },
    axiosurl: 'https://account.aso.adjz.com' // '/api' // 
}
export default deleteNull


// WEBPACK FOOTER //
// ./src/base/api/prototype.js